import {BUTTON_BACKGROUND, BUTTON_FONT, BUTTON_TEXT_COLOR} from "../../../../../utils/constants"
import {WIDTH} from "../../../utils/constants"

export function menuStyles() {
    return {
        minWidth: WIDTH,
        width: WIDTH,
        display: "flex",
        justifyContent: "space-between",
        position: "relative" as "relative"
    }
}
